import React from "react"
import "./index.scss"

const InternalError = () => {
  return (
    <div data-testid="error" className="errorContainer">
      <div className="errorSection">
        <div className="left">
          <div className="error-icon"></div>
        </div>
        <div className="right">
          <p>Something went wrong.</p>
          <p>Please try again later</p>
        </div>
      </div>
    </div>
  )
}
export default InternalError
